import echarts from 'echarts'
import filters from '@/filters'
var option = {
  backgroundColor: "rgba(0,0,0,0)",
  grid: {
    "left": "30",
    "top": "10",
    "right": "10",
    "bottom": "20"
  },
  tooltip: {
    show: true,    // 是否显示提示框组件
    trigger: 'axis',
    backgroundColor: "#3C4252"
  },
  position: function (point, params, dom, rect, size) {
    var x = 0; // x坐标位置
    var y = 0; // y坐标位置
    // 当前鼠标位置
    var pointX = point[0];
    var pointY = point[1];
    // 提示框大小
    var boxWidth = size.contentSize[0];
    var boxHeight = size.contentSize[1];

    // boxWidth > pointX 说明鼠标左边放不下提示框
    if (boxWidth > pointX) {
      x = pointX + 10;
    } else { // 左边放的下
      x = pointX - boxWidth - 10;
    }

    // boxHeight > pointY 说明鼠标上边放不下提示框
    if (boxHeight > pointY) {
      y = 5;
    } else { // 上边放得下
      y = pointY - boxHeight;
    }
    return [x, y]
  },
  xAxis: {
    type: 'category',
    boundaryGap: ['10%', '10%'],
    axisLine: {
      show: false, //隐藏x轴
    },
    axisTick: {
      show: false,  //刻度线
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: 'rgba(255,255,255,0.55)', // 坐标轴文字颜色
        fontSize: 12, // 坐标轴文字大小
      },
    },
    data: []
  },
  yAxis: [
    {
      type: 'value',
      position: 'left',
      axisTick: {
        show: false,  //刻度线
      },
      axisLine: {
        show: false, //隐藏y轴
      },
      axisLabel: {
        show: false,
        textStyle: {
          color: '#8890A6', // 坐标轴文字颜色
          fontSize: 10, // 坐标轴文字大小
          padding: [0, 10, 0, 0]
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: ["rgba(255,255,255,0.04)"],
        },
      },
    }
  ],
  series: [
    {
      name: '',
      data: [],
      type: 'bar',
      itemStyle: {
        normal: {
          color: (val) => {
            if (val.name == '1') {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#FFCA5C'
              }, {
                offset: 1,
                color: 'rgba(255,202,92,0)'
              }], false)
            } else {
              return '#3C4252'
            }
          }
        },
      },
      barMaxWidth: 24,
    }
  ]
};
export default option